import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers';
import Box from '@mui/material/Box';
import dayjs, { Dayjs } from 'dayjs';

type Props = {
  value: Dayjs | null;
  handleChange: (value: Dayjs | null) => void;
  dateFormat: string;
};

const CustomPropertyDatePicker = ({ value, handleChange, dateFormat }: Props) => {
  const userDateFormat = (dateFormat || 'YYYY/MM/DD').toUpperCase();
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          overflow: 'visible',
          paddingTop: '0px',
        }}
      >
        <DatePicker
          value={value ? dayjs(value) : null}
          onChange={(newValue) => handleChange(newValue)}
          format={userDateFormat}
          slotProps={{
            textField: {
              size: 'small',
              sx: {
                width: '100%',
              },
              variant: 'standard',
            },
            openPickerButton: {
              disableRipple: true,
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default CustomPropertyDatePicker;
